import { action } from 'typesafe-actions';
import {
  SPORTS_FAILURE,
  SPORTS_REQUEST,
  SPORTS_SUCCESS,
} from '../../constants/sports';

export const sportsRequestAction = () => action(SPORTS_REQUEST);
export const sportsSuccessAction = (data: any) => action(SPORTS_SUCCESS, data);
export const sportsFailureAction = (e: any) => action(SPORTS_FAILURE, e);

export const sportsActions = {
  sportsRequestAction,
  sportsSuccessAction,
  sportsFailureAction,
};
